// extracted by mini-css-extract-plugin
export default {"searchbar":"SearchBar_searchbar__-d44V","checkbox":"SearchBar_checkbox__L4xhu"};